var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 247,
    viewBox: "0 0 131 247",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.83 178.871C144.966 106.241 85.6594 83.4552 59.9891 81.1414C0.972135 56.599 -10.3103 -0.892439 10.0696 -48.3643C30.4496 -95.8362 179.864 -136.238 274.459 -85.2461C369.054 -34.2541 357.546 142.849 342.208 201.832C326.869 260.815 216.661 269.66 176.83 178.871Z",
    fill: "#C317F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/vector7.fe947dfe571bcbc2f657326ea259b728.svg";
export { ForwardRef as ReactComponent };